import { OrgTypes } from '@mode/shared/contract-common';
import { createAction, props } from '@ngrx/store';

export const loadAdmins = createAction('[Admin] Load Admins', props<{ username: string }>());

export const loadAdminsSuccess = createAction(
  '[Admin] Load Admins Success',
  props<{ admins: ReadonlyArray<OrgTypes.Admin> }>()
);

export const loadAdminsFailure = createAction('[Admin] Load Admins Failure', props<{ error: any }>());
